export default __webpack_public_path__ + "static/5-3b056efcc5f8e7d67023f5761adaca53.png";